'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Cancel(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', className: 'icon-svg-cancel ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    title ? _react2.default.createElement(
      'title',
      null,
      title
    ) : null,
    _react2.default.createElement('path', { fill: color, d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12 10.5l-1.5 1.5-2.5-2.5-2.5 2.5-1.5-1.5 2.5-2.5-2.5-2.5 1.5-1.5 2.5 2.5 2.5-2.5 1.5 1.5-2.5 2.5 2.5 2.5z' })
  );
}

Cancel.propTypes = _.IconPropTypes;

exports.default = Cancel;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Cancel/Cancel.js
// module id = 70
// module chunks = 0 1 2 3 4 5 6 7 8 9